module.exports = __webpack_public_path__ + "static/media/UnitedArabEmirates.da3de42b.svg";